import { Users, DollarSign, Inbox, Sparkles } from "lucide-react";
import { ADMIN_STATUSES } from "./StatusBadge";

const Card = ({ label, value, sub, icon: Icon, testId }) => (
  <div className="rounded-2xl border bg-card p-4 shadow-soft" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <Icon className="h-4 w-4 text-muted-foreground" />
    </div>
    <p className="mt-2 text-3xl font-bold tracking-tight text-foreground" data-testid={`${testId}-value`}>{value}</p>
    {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
  </div>
);

export const AdminStats = ({ data }) => {
  const a = data.accounts;
  return (
    <div className="space-y-3" data-testid="admin-stats">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Card label="Accounts" value={a.total} icon={Users} testId="admin-stat-accounts" sub={`${a.today} today · ${a.last_7d} in 7d · ${a.last_30d} in 30d`} />
        <Card label="Estimated MRR" value={`$${data.mrr.amount.toLocaleString("en-US")}`} icon={DollarSign} testId="admin-stat-mrr"
          sub={`${data.mrr.paying} paying × $${data.mrr.price} (active Stripe only)`} />
        <Card label="Leads received" value={data.leads.total} icon={Inbox} testId="admin-stat-leads" sub={`${data.leads.last_30d} in the last 30 days`} />
        <Card label="AI this month" value={data.ai_month.analyses + data.ai_month.retries} icon={Sparkles} testId="admin-stat-ai"
          sub={`${data.ai_month.analyses} analyses · ${data.ai_month.retries} retries · ${data.previews_month} previews`} />
      </div>
      <div className="flex flex-wrap gap-2 rounded-2xl border bg-card p-4 shadow-soft" data-testid="admin-status-breakdown">
        {Object.entries(ADMIN_STATUSES).map(([key, { label, tone }]) => (
          <span key={key} className={`rounded-lg px-2.5 py-1.5 text-xs font-medium ${tone}`} data-testid={`admin-status-count-${key}`}>
            {label}: <span className="font-bold">{data.by_status[key] || 0}</span>
          </span>
        ))}
        <span className="rounded-lg bg-red-600 px-2.5 py-1.5 text-xs font-medium text-white" data-testid="admin-status-count-suspended">Suspended: <span className="font-bold">{data.suspended}</span></span>
        {data.double_billing > 0 && (
          <span className="rounded-lg bg-yellow-200 px-2.5 py-1.5 text-xs font-medium text-yellow-900" data-testid="admin-status-count-double-billing">
            Comped + paying in Stripe: <span className="font-bold">{data.double_billing}</span>
          </span>
        )}
      </div>
    </div>
  );
};
